import { observable } from 'mobx'
import { SportPoll } from 'pages/projects/SportPoll/SportForm/types'
import { GENERAL_STORE } from 'store/GeneralStore'
import { RootStore } from 'store/RootStore'
import { Api } from 'utilities'

export const SPORT_POLL_STORE =
  'SPORT_POLL_STORE'

export class SportPollStore {
  private rootStore: RootStore;

  constructor (rootStore: RootStore) {
    this.rootStore = rootStore
  }

  @observable sportPollList = [];

  createPoll = async (payload: SportPoll) => {
    const response = await Api.post('/poll/createPoll', payload)
    // Push the sport poll list
    this.sportPollList.push(response)
    return response
  };

  updatePoll = async (payload: SportPoll) => {
    const { sportPollList } = this
    const index = sportPollList.findIndex((sportPoll: SportPoll) => sportPoll.pollId === payload.pollId)
    sportPollList[index] = payload
    return Api.put('/poll/update', payload)
  };

  deletePoll = async (pollId: number) => {
    this.sportPollList = this.sportPollList.filter((sportPoll: SportPoll) => sportPoll.pollId !== pollId)
    return Api.delete(`/poll/${pollId}/delete`)
  };

  fetchSportPoll = async (projectId: string) => {
    const {
      [GENERAL_STORE]: { setLoadingOn, setLoadingOff }
    } = this.rootStore
    setLoadingOn()
    const response = await Api.get(`/poll/${projectId}/getPolls`)

    if (response) {
      setLoadingOff()
      this.sportPollList = response as SportPoll[]
      return response
    }

    setLoadingOff()
  };

  clearStore = () => {
    this.sportPollList = []
  }
}
